import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MAIN_SECTIONS, PATH } from '../../../../constants';
import * as api from '../../../../api';
import './CategoryIntroVideo.css';
import { detailIntroPlayed } from '../../../../redux/actions';

class CategoryIntroVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoActive: false,
    };
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    this.checkActiveState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkActiveState(nextProps);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props.category !== nextProps.category) ||
      (!this.state.videoActive && nextState.videoActive);
  }

  // -------------------------------------------------------
  // Played
  // -------------------------------------------------------

  checkActiveState(props) {
    this.setState({
      videoActive: (
        !props.detailActive &&
        api.getHash().length > 0 &&
        props.introPlayed.indexOf(props.category) === -1
      ),
    });
  }

  trySavePlayed() {
    const { category, introPlayed } = this.props;
    if (introPlayed.indexOf(category) === -1) {
      this.props.detailIntroPlayed(category);
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { category } = this.props;
    const { videoActive } = this.state;

    const categoryData = MAIN_SECTIONS[category];

    return (
      <div className="intro-video-cont">
        <div className="intro-video">
          <div className="video-frame-cont">
            {!videoActive &&
            <button
              className="video-start-btn"
              onClick={() => {
                this.setState({
                  videoActive: true,
                });
              }}
            >
              <img
                className="thumb"
                src={api.videoImageUrl({
                  bonus: categoryData.video,
                })}
                alt="Intro"
              />
              <img
                className="ico"
                src={`${PATH.IMG}ico/ico-play.png`}
                alt="Přehrát"
              />
            </button>
            }
            {videoActive &&
            <iframe
              className="video-frame"
              title={categoryData.title}
              src={api.getVideoSource({ bonus: categoryData.video })}
              onLoad={() => this.trySavePlayed()}
              allowFullScreen
            />
            }
          </div>
          <div className="range">{categoryData.range}</div>
          <div className="title">{categoryData.title}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  introPlayed: state.dataDetail.introPlayed,
});

const mapDispatchToProps = dispatch => ({
  detailIntroPlayed: category => dispatch(detailIntroPlayed(category)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CategoryIntroVideo);



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/CategoryIntroVideo/CategoryIntroVideo.js